module.exports = __webpack_public_path__ + "static/img/logo-keia.43062c5.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/logo-keia.png
// module id = C20k
// module chunks = 0